import useCustomAnalyticsState from "components/hooks/use-custom-analytics-state";
import { createUrl } from "lib/utils";

export default function CheckoutLink({ href, onClick, className, children }: { href?: string, className?: string, onClick?: React.MouseEventHandler<HTMLAnchorElement>, children?: React.ReactNode }) {
  const { state, loading } = useCustomAnalyticsState();

  let checkoutUrl = href;
  if (href && state?.page?.queryParams) {
    checkoutUrl = createUrl(href, new URLSearchParams(state.page.queryParams));
  }

  const disabledClass = className ? `${className}-disabled` : 'disabled';
  const cssClass = `${className} ${loading ? disabledClass : ''}`

  return (
    <a href={checkoutUrl} onClick={onClick} className={cssClass}>
      {children}
    </a>
  );
}
